<template>
  <div class="page-wrapper">
    <div class="content container-fluid">
      <div class="page-header">
        <div class="row align-items-center">
          <div class="col">
            <h3 class="page-title">Danh sách Fanpage</h3>
            <ul class="breadcrumb">
              <li class="breadcrumb-item"><a href="index.html">Dashboard</a></li>
              <li class="breadcrumb-item active">Danh sách Fanpage</li>
            </ul>
          </div>
          <div class="col-auto float-right ml-auto">
            <a href="#" class="btn add-btn" data-toggle="modal" data-target="#add_fanpage_modal">
              <i class="fa fa-plus"></i> Thêm Fanpage
            </a>
          </div>
        </div>
      </div>
      <!-- Table -->
      <div class="row">
        <div class="col-md-12">
          <div>
            <table class="table table-striped custom-table mb-0 datatable">
              <thead>
                <tr>
                  <th>Fanpage ID</th>
                  <th>Tên Fanpage</th>
                  <th class="text-right">Hành động</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="fanpage in fanpages" :key="fanpage.id">
                  <td>{{ fanpage.maTrang }}</td>
                  <td>{{ fanpage.name }}</td>
                  <td class="text-right">
                    <div class="dropdown dropdown-action">
                      <a href="#" class="action-icon dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                        <i class="material-icons">more_vert</i>
                      </a>
                      <div class="dropdown-menu dropdown-menu-right">
                        <a class="dropdown-item"
                          href="#"
                          data-toggle="modal"
                          data-target="#edit_fanpage_modal"
                          @click="editFanpage(fanpage)">
                          <i class="fa fa-pencil m-r-5"></i> Sửa
                        </a>
                        <a class="dropdown-item"
                          href="#"
                          data-toggle="modal"
                          data-target="#delete_fanpage_modal"
                          @click="confirmDelete(fanpage.id)">
                          <i class="fa fa-trash-o m-r-5"></i> Xóa
                        </a>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr v-if="fanpages.length === 0 && !loading">
                  <td colspan="3" class="text-center">Không tìm thấy Fanpage nào.</td>
                </tr>
                <tr v-if="loading">
                  <td colspan="3" class="text-center">Đang tải...</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Pagination -->
      <div class="row">
        <div class="col-sm-12 col-md-5">
          <div class="dataTables_info" role="status" aria-live="polite">
            Hiển thị {{ currentPage * pageSize + 1 }} đến
            {{ Math.min((currentPage + 1) * pageSize, totalElements) }} của {{ totalElements }} mục
          </div>
        </div>
        <div class="col-sm-12 col-md-7">
          <div class="dataTables_paginate paging_simple_numbers">
            <ul class="pagination">
              <li class="paginate_button page-item previous" :class="{ disabled: currentPage === 0 }">
                <a href="#" class="page-link" @click.prevent="goToPage(currentPage - 1)">Previous</a>
              </li>
              <li class="paginate_button page-item"
                  :class="{ active: pageNum === currentPage + 1 }"
                  v-for="pageNum in totalPages"
                  :key="pageNum">
                <a href="#" class="page-link" @click.prevent="goToPage(pageNum - 1)">{{ pageNum }}</a>
              </li>
              <li class="paginate_button page-item next" :class="{ disabled: currentPage === totalPages - 1 }">
                <a href="#" class="page-link" @click.prevent="goToPage(currentPage + 1)">Next</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal thêm -->
    <div id="add_fanpage_modal" class="modal custom-modal fade" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Thêm Fanpage</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="addFanpage">
              <div class="form-group">
                <label>Fanpage ID <span class="text-danger">*</span></label>
                <input class="form-control" type="text" v-model="newFanpage.maTrang" required />
              </div>
              <div class="form-group">
                <label>Tên Fanpage <span class="text-danger">*</span></label>
                <input class="form-control" type="text" v-model="newFanpage.name" required />
              </div>
              <div class="form-group">
                <label>Token <span class="text-danger">*</span></label>
                <textarea class="form-control" v-model="newFanpage.token" required></textarea>
              </div>
              <div class="submit-section">
                <button type="submit" class="btn btn-primary submit-btn">Thêm</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal sửa -->
    <div id="edit_fanpage_modal" class="modal custom-modal fade" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Sửa Fanpage</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="updateFanpage">
              <div class="form-group">
                <label>Fanpage ID <span class="text-danger">*</span></label>
                <input class="form-control" type="text" v-model="currentFanpage.maTrang" required />
              </div>
              <div class="form-group">
                <label>Tên Fanpage <span class="text-danger">*</span></label>
                <input class="form-control" type="text" v-model="currentFanpage.name" required />
              </div>
              <div class="form-group">
                <label>Token <span class="text-danger">*</span></label>
                <textarea class="form-control" v-model="currentFanpage.token" required></textarea>
              </div>
              <div class="submit-section">
                <button type="submit" class="btn btn-primary submit-btn">Lưu thay đổi</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal xóa -->
    <div class="modal custom-modal fade" id="delete_fanpage_modal" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <div class="form-header">
              <h3>Xóa Fanpage</h3>
              <p>Bạn có chắc chắn muốn xóa Fanpage này không?</p>
            </div>
            <div class="modal-btn delete-action">
              <div class="row">
                <div class="col-6">
                  <a href="javascript:void(0);" class="btn btn-primary continue-btn" @click="deleteFanpage">Xóa</a>
                </div>
                <div class="col-6">
                  <a href="javascript:void(0);" data-dismiss="modal" class="btn btn-primary cancel-btn">Hủy</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, reactive } from 'vue';
import api from '../api'; 
import { useToast } from 'vue-toastification';

const toast = useToast();

const fanpages = ref([]);
const loading = ref(true);

const newFanpage = reactive({
  name: '',
  token: '',
  fanpageID: ''
});

const currentFanpage = reactive({
  id: null,
  name: '',
  token: '',
  fanpageID: ''
});

const fanpageToDeleteId = ref(null);

const currentPage = ref(0);
const pageSize = ref(10);
const totalElements = ref(0);
const totalPages = ref(0);

const fetchFanpages = async () => {
  loading.value = true;
  try {
    const response = await api.get('/api/fanpages', {
      params: { page: currentPage.value, size: pageSize.value }
    });
    const data = response.data;
    fanpages.value = data.content ?? data;
    totalElements.value = data.totalElements ?? data.length;
    totalPages.value = data.totalPages ?? 1;
  } catch (error) {
    console.error('Lỗi khi lấy danh sách fanpage:', error);
    toast.error('Không thể tải danh sách fanpage.');
  } finally {
    loading.value = false;
  }
};

const goToPage = (page) => {
  if (page >= 0 && page < totalPages.value) {
    currentPage.value = page;
    fetchFanpages();
  }
};

const addFanpage = async () => {
  try {
    await api.post('/api/fanpages', newFanpage);
    toast.success('Thêm fanpage thành công!');
    resetNewFanpageForm();
    fetchFanpages();
  } catch (error) {
    console.error('Lỗi khi thêm fanpage:', error);
    toast.error('Có lỗi xảy ra khi thêm fanpage.');
  }
};

const editFanpage = (fanpage) => {
  Object.assign(currentFanpage, { ...fanpage });
};

const updateFanpage = async () => {
  try {
    await api.put(`/api/fanpages/${currentFanpage.id}`, currentFanpage);
    toast.success('Cập nhật fanpage thành công!');
    fetchFanpages();
  } catch (error) {
    console.error('Lỗi khi cập nhật fanpage:', error);
    toast.error('Có lỗi xảy ra khi cập nhật fanpage.');
  }
};

const confirmDelete = (id) => {
  fanpageToDeleteId.value = id;
};

const deleteFanpage = async () => {
  try {
    await api.delete(`/api/fanpages/${fanpageToDeleteId.value}`);
    toast.success('Xóa fanpage thành công!');
    fetchFanpages();
    fanpageToDeleteId.value = null;
  } catch (error) {
    console.error('Lỗi khi xóa fanpage:', error);
    toast.error('Có lỗi xảy ra khi xóa fanpage.');
  }
};

const resetNewFanpageForm = () => {
  newFanpage.name = '';
  newFanpage.token = '';
  newFanpage.fanpageID = '';
};

onMounted(() => {
  fetchFanpages();
});
</script>
